// `internal-task` intentionally omitted — doc marks it commented/unsupported in the backend enum.
export default Object.freeze({
  User: 'user',
  Position: 'position',
  Area: 'area',
  UserGroup: 'user-group',
  UserGroupUser: 'user-group-user',
  Environment: 'environment',
  EnvironmentUser: 'environment-user',
  Delegation: 'delegation',
  DelegationConfiguration: 'delegation-configuration',
  GlobalEntityApproverByAreas: 'global-entity-approver-by-areas',
  GlobalEntityApproverByPositions: 'global-entity-approver-by-positions',
  GlobalEntityApproverByUserGroups: 'global-entity-approver-by-user-groups',
  GlobalEntityApproverUsers: 'global-entity-approver-users',
  GlobalUserGroupApproverByAreas: 'global-user-group-approver-by-areas',
  GlobalUserGroupApproverByPositions: 'global-user-group-approver-by-positions',
  GlobalUserGroupApproverUsers: 'global-user-group-approver-users',
  ReportTrace: 'report-trace',
  ProcessInstance: 'process-instance',
  ChatThreadParticipant: 'chat-thread-participant',
  AIAgentVector: 'ai-agent-vector',
});
